<template>
    <div class="lives-list-section">
        <!-- 4直播 -->
        <van-row @click="go_live_detail(dataItem.content, dataItem)">
            <div class="lives-list-section-box">
                <div class="lives-list-section-left">
                    <img class="lives-list-section-left-img" :src="dataItem.content.cover_img" />
                    <div class="lives-list-section-left-top" v-if="dataItem.top == 1">
                        <img src="/static/v4/tag_top.svg" alt="" />
                    </div>
                    <div v-else-if="dataItem.content.type == 2" class="lives-list-section-left-zl">
                        <img src="static/v4/icon_list_tag_column.svg" class="img1">
                    </div>
                    <div v-else-if="dataItem.content.live_status == 0" class="lives-list-section-left-zl">
                        <img src="/static/v4/icon_list_tag_live_count_down.svg" class="img2">
                    </div>
                    <div v-else-if="dataItem.content.live_status == 1" class="lives-list-section-left-zl">
                        <img src="/static/v4/icon_list_tag_live_process.svg" class="img3">
                    </div>
                    <div v-else class="lives-list-section-left-zl">
                        <img src="static/v4/icon_list_tag_live_history.svg" class="img1">
                    </div>
                </div>
                <div class="lives-list-section-right">
                    <div class="lives-list-section-right-title" v-html="dataItem.content.title"></div>
                    <div class="lives-list-section-right-detail chu" style="bottom: 0" v-if="dataItem.content.type === 2">
                      <span>共{{ dataItem.content.total_count }}期</span>
                      <span style="margin-left: 8px">{{ dataItem.content.view_count }}人观看</span>
                    </div>
                    <div class="lives-list-section-right-detail" style="bottom: 0" v-else-if="dataItem.content.live_status == 0">
                        <span>{{ dataItem.content.start_at }}</span>
                        <span class="live-list-section-right-detail-join apply" @click.stop="liveApply(dataItem.content,dataItem.content.id)" v-if="dataItem.content.live_status == 0 && dataItem.content.isAppointment == 0">一键预约</span>
                        <span class="live-list-section-right-detail-join applied" v-else-if="dataItem.content.live_status == 0 && dataItem.content.isAppointment == 1">已预约</span>
                    </div>
                    <div class="lives-list-section-right-detail" style="bottom: 0" v-else-if="dataItem.content.live_status == 1">
                        <span>{{ dataItem.content.start_at }}</span>
                        <span class="lives-list-section-right-detail-join add">加入</span>
                    </div>
                    <div class="lives-list-section-right-detail" style="bottom: 0" v-else>
                        <span>{{ dataItem.content.view_count }}人观看</span>
                    </div>
                </div>
            </div>
        </van-row>
      <van-overlay :show="applyShow">
        <div class="apply-overlay-box">
          <div class="apply-overlay-box-wrap">
            <div class="apply-overlay-box-wrap-bg">
              <img src="/static/v4/pic_tip_success_bg.svg" />
            </div>
            <div class="apply-overlay-box-wrap-close">
              <img src="/static/v4/icon_tip_close.svg" alt="" @click="closeApplyShow" />
            </div>
            <div class="apply-overlay-box-wrap-title">
              <span>预约成功提醒</span>
            </div>
            <div class="apply-overlay-box-wrap-content">
              您已成功预约本次直播，开播前将收到短信提醒。您也可在 <span>“我的”-“我的预约”</span> 中查看您的预约情况。
              扫码领取学习资料。
            </div>
            <div class="apply-overlay-box-wrap-img">
              <img src="/static/v4/code.jpg" />
            </div>
          </div>
        </div>
      </van-overlay>
    </div>
</template>

<script>
import Interface from '@/util/interface'

export default {
    props: {
        dataItem: {
            type: Object,
            required: true,
            liveItem: {}
        }
    },
    data() {
      return {
        applyShow: false
      }
    },
    methods: {
        go_live_detail(item, i) {
            Interface.getData('get', `/course/api/content_relation/${i.id}/view`)
            this.getViewCount(i)
            Interface.goLiveDetail(this, {id: item.id, type: item.type, isAppointment: item.isAppointment, live_status: item.live_status})

        },
        // 直播-一键预约
        liveApply(item,id) {
            this.liveItem = item
            if (!item.isAppointment) {
                // 判断是否认证 0 未认证   1已认证
                let user = localStorage.getItem('user')

                let is_complete = JSON.parse(user).is_complete

                if (is_complete == 1) {
                    Interface.getData('get', Interface.v4.apply + '/' + id).then(res => {
                        if (res.code == 0) {
                            this.applyShow = true
                            item.isAppointment = 1
                        }
                    })
                } else {
                    // 去认证
                    this.$dialog
                        .confirm({
                            title: '需要登录',
                            message: '为了方便学习课程,需要您登录认证',
                            confirmButtonText: '去认证'
                        })
                        .then(() => {
                            sessionStorage.setItem('back-url', this.$route.path)
                            this.$router.push({ name: 'login' })
                        })
                        .catch(() => {
                            // on cancel
                        })
                }
            }else{
                Interface.goLiveDetail(this, item)
            }
        },
        getViewCount(item) {
            Interface.getData('get', `/course-phase/api/recommend_v2/${item.id}/view`)
        },
      // 关闭预约弹框
      closeApplyShow() {
        this.applyShow = false
        // 同时跳转到直播间
        this.$router.push({ name: 'live-detail-home', params: { id: this.liveItem.id } })
      },
    }
}
</script>

<style lang="scss" scoped>
.lives-list-section {
    border-bottom: 1px solid #f2f2f2;
    padding: 10px 0 10px 0;
    background-color: #ffffff;
    margin: 10px 10px;
    border-radius: 10px;

    &-title {
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #222222;
        letter-spacing: 0;
        margin-left: 16px;
        font-weight: 500;
        position: relative;
        span {
            position: absolute;
            bottom: 0vw;
            left: 0;
            width: 30px;
            height: 6px;
            background-color: #c7f3e7;
            border-radius: 0.8vw;
            z-index: 1;
        }
    }

    &-box {
        width: 355px;
        height: 72px;
        position: relative;
        padding-bottom: 15px;
        padding-bottom: 0;
    }

    &-left {
        width: 130px;
        height: 73px;
        float: left;
        position: relative;
        border-radius: 6px;
        margin-left: 10px;
        &-img {
            width: 130px;
            height: 73px;
            background: #eff3fa;
            border-radius: 6px;
            >>> .van-image__img,
            img {
                border-radius: 6px;
            }
        }
        &-zl {
            position: absolute;
            top: 0;
            left: 0;
            //background: #10c3b5;
            //border-radius: 6px 3px 3px 3px;
            //font-family: PingFangSC-Medium;
            //font-size: 10px;
            //color: #ffffff;
            //letter-spacing: 0;
            //padding: 1px 6px;
            .img1 {
                width: 30px;
                height: 18px;
            }
            .img2 {
                width: 40px;
                height: 18px;
            }
            .img3 {
                width: 50px;
                height: 18px;
            }
            &.active {
                background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
                border-radius: 6px 3px 3px 3px;
            }
            &.current {
                background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
                border-radius: 6px 3px 3px 3px;
                font-family: PingFangSC-Medium;
                font-size: 10px;
                color: #ffffff;
                letter-spacing: 0;
                img {
                    width: 12px;
                    height: 12px;
                    margin-bottom: -3px;
                }
            }
        }
        &-time {
            width: 100%;
            bottom: 0px;
            position: absolute;
            color: #fff;

            font-family: Avenir-Heavy;
            font-size: 11px;
            letter-spacing: 0;
            text-align: right;

            background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.4) 100%);
            border-radius: 0 0 6px 6px;

            span {
                display: inline-block;
                margin-bottom: 4px;
                margin-right: 8px;
            }
        }
        &-top{
            position: absolute;
            top: 4px;
            left: 4px;
            width: 18px;
            height: 18px;
            border-radius: 3px;
            img {
                width: 18px;
                height: 18px;
                border-radius: 3px;
            }
        }
    }

    &-right {
        float: left;
        margin-left: 10px;
        text-align: left;
        &-title {
            font-family: PingFangSC-Medium, PingFang SC;
            font-size: 14px;
            color: #222222;
            letter-spacing: 0;
            line-height: 22px;
            font-weight: 500;
            // text-align: justify;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            word-break: break-all;
            /deep/ .light {
                color: #D81D20;
            }
        }
        &-author {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #404040;
            letter-spacing: 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            word-break: break-all;
        }
        &-detail {
            width: 193px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #9d9d9d;
            letter-spacing: 0;

            text-align: left;
            position: absolute;
            bottom: 15px;
            word-break: break-all;
            &-join {
                float: right;
                display: inline-block;
                font-family: PingFangSC-Medium;
                font-size: 13px;
                color: #d81d20;

                background: #ffece8;
                border-radius: 16.5px;

                padding: 5px 8px;
                margin-top: -10px;
                margin-left: 5px;
            }
          .apply{
            padding: 3px 10px;
            background: #FFF0EE;
            border-radius: 17px;
            font-size: 13px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #D81D20;
          }
          .applied{
            padding: 3px 10px;
            background: #FFF0EE;
            border-radius: 17px;
            font-size: 13px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #D81D20;
          }
          .add{
            padding: 3px 10px;
            background: #FFF0EE;
            border-radius: 17px;
            font-size: 13px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #D81D20;
          }
        }
      .chu{
        display: inline-block;
      }
    }

    .lives-list-section-left {
    }
    .lives-list-section-right {
        width: 193px;
    }
    .lives-list-section {
        padding-top: 14px;
        margin-top: 0px;

        // .course-list-section-right-title,
        .lives-list-section-right-title {
            padding-right: 14px;
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
        }
    }
}

.ellipsis-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.apply-overlay-box{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 327px;
  height: 380px;
  background: #FFFFFF;
  border-radius: 12px;
  &-wrap{
    position: relative;
    &-bg{
      position: absolute;
      left: 0;
      top: 0;
    }
    &-close{
      text-align: right;
      padding-right: 16px;
      img{
        margin-top: 16px;
        width: 15px;
        height: 15px;
      }
    }
    &-title{
      text-align: center;
      span{
        font-size: 17px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222222;
      }
    }
    &-content{
      margin-top: 14px;
      padding: 0 28px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      text-align: justify;
      line-height: 22px;
      span{
        color: #222;
        margin: 0 5px;
      }
    }
    &-img{
      margin-top: 50px;
      text-align: center;
      img{
        width: 140px;
        height: 140px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/lives.vue